/*
 * message wrapper for data 
 * @author: Jason Wong
 * @since: 2018-12-07 09:38:44
 */
let staticEmptySuccessMessage = null;

export default class Message{
    isSuccessful;msg;

    constructor(isSuccessful,msg){
        this.isSuccessful = isSuccessful;
        this.msg = msg;
    }

    get emptySuccessMessage(){
        if(!staticEmptySuccessMessage){
            staticEmptySuccessMessage = new Message(true);
        }
        return staticEmptySuccessMessage;
    }

    static createErrorMessage(err){
        return new Message(false,err);
    }
}